export const APP_TEST_IDS = {
  navigationGuard: {
    modal: 'app.navigationGuard.modal.unsavedChanges',
  },
} as const;
